import styled from 'styled-components/macro';

export const CustomVideo = styled.video`
  min-width: 321px;
  width: 100%;
  height: inherit;
  object-fit: cover;
`;
